import { render, staticRenderFns } from "./UcContractRevisionDropdownItem.yaml?vue&type=template&id=3361024b&component"
import script from "./UcContractRevisionDropdownItem.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractRevisionDropdownItem.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports